import {FC, cloneElement, useState} from "react";
import {Box, Button, FormControl, InputLabel, Menu, MenuItem, Select, Typography} from "@mui/material";
import {makeStyles} from "tss-react/mui";

export interface ITableSettings {
	densePadding: boolean
}

export interface IProps {
	bulkActions?: {onApply: (e: any) => void, label: string, subForm: JSX.Element}[],
	selected?: any[]
}

const useStyles = makeStyles()((theme) => ({
	adminTableSearchInput: {
		display: "flex",
		justifyContent: "center",
		cursor: "pointer",
		flexDirection: "column",
		padding: "0 15px",
		gap: "10px",
		"& p": {
			fontWeight: 700,
			fontSize: "12px"
		}
	},
	icon: {
		cursor: "pointer"
	},
	menu: {
		marginTop: "10px",
		"& > div": {
			minWidth: "300px",
			padding: "10px"
		},
		"& button": {
			borderRadius: "5px",
			float: "left"
		}
	},
	select: {
		"& fieldset": {
			borderColor: theme.palette.common.white
		},
		"& svg path": {
			fill: theme.palette.common.white
		}
	}
}));

export const AdminTableBulkActionsInput: FC<IProps> = ({bulkActions, selected}) => {
	const {classes} = useStyles();
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const [selectedAction, setSelectedAction] = useState<string>("");
	const [bulkActionFormData, setBulkActionFormData] = useState<any>();
	const open = Boolean(anchorEl);

	const handleClick = (event: React.MouseEvent<HTMLDivElement>): void => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = (): void => {
		setAnchorEl(null);
	};

	const action = bulkActions?.find(e => e.label === selectedAction);
	const bulkActionButtonDisabled = !selected || selected.length === 0;
	return (
		<>
			<Box
				onClick={bulkActionButtonDisabled ? undefined: handleClick}
				className={classes.adminTableSearchInput}
				style={bulkActionButtonDisabled ? {cursor: "default", opacity: 0.5} : {}}>
				<Typography>Bulk actions</Typography>
			</Box>
			<Menu
				id="admin-table-menu"
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				className={classes.menu}
				MenuListProps={{
					"aria-labelledby": "basic-button"
				}}
			>
				<Box>
					<FormControl fullWidth>
						<InputLabel id="bulk-action-select-label">Action</InputLabel>
						<Select
							variant="outlined"
							className={classes.select}
							labelId="bulk-action-select-label"
							id="bulk-action-select"
							value={selectedAction}
							label="Action"
							onChange={(e) => setSelectedAction(e.target.value)}
						>
							{bulkActions?.map((e, i) => (<MenuItem key={i} value={e.label}>{e.label}</MenuItem>))}
						</Select>
					</FormControl>
				</Box>

				<Box padding={"10px"}/>
				{action?.subForm && cloneElement(action.subForm, {onChange: (e: any) => setBulkActionFormData(e), selected})}

				<Box padding={"10px"}/>

				<Button disabled={!bulkActionFormData} onClick={() => action?.onApply(bulkActionFormData)}>Apply Action</Button>
			</Menu>
		</>

	);
}